const config = {
  apiVer: '1.0.0',
  localhost: 'http://localhost:8084/',
  develURL: 'https://parkman-be.stringdata.cz/',
  recaptchaCode: '6Ldve88ZAAAAADtnPwGwOSfRbMQpxZ7FNdIJVe2W'
};

export default config;
